import { render, staticRenderFns } from "./LandingReviewsWedding.vue?vue&type=template&id=22dcf1ba&scoped=true"
import script from "./LandingReviewsWedding.vue?vue&type=script&lang=js"
export * from "./LandingReviewsWedding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcf1ba",
  null
  
)

export default component.exports